export const PROCESS_SUMMARY_FIELDS = [
  "code",
  "cbm",
  "cartons",
  "kg",
  "content_class",
  "container_size",
  "priority",
  "splits",
  "door_name",
  "people_active",
  "people_tagged",
  "unloaded_boxes",
  "tot_labor_man_mins",
  "direction",
  "cph",
  "last_5min_rate_cpm",
  "estimated_start",
  "estimated_end",
  "end_time_first_prediction",
  "expected_cph",
  "estimated_undock",
  "tz_name",
  "effort_accuracy",
  "linear_accuracy",
  "notes",
];

export const PROCESS_CHARTS_SYNC_ID = 'UNLOADING_PROCESS';
